import { SaleDataGetSalesQuery } from "./sales/SaleDataQueries";
import { useAgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { useDispatch } from 'react-redux';
import { salesDataSlice, useCurrentSale } from "./sales/SaleDataStore";
import { AgTechAppLoadingProps } from "@agtech/core/data/loading/AgTechAppLoading";
import { useSaleRealtimeConnection } from "./realtime/SaleRealtimeConnection";

const SalesAppDataContext = (props: AgTechAppLoadingProps) => {
    const dispatch = useDispatch();
    const currentSale = useCurrentSale();

    useSaleRealtimeConnection();

    useAgTechQuery({
        query: SaleDataGetSalesQuery,
        settings: {
            eventHandlers: {
                onQuerySuccess: (saleDetails) => {
                    // Only seed the initial sale here. This query is refetched whenever
                    // ChangeSelectedSale clears the query cache, and re-running this on every
                    // refetch would stomp the user's explicit selection back to the newest sale.
                    if (currentSale.id !== 0) {
                        return;
                    }

                    const defaultSale = saleDetails[0];

                    dispatch(salesDataSlice.actions.setCurrentSale({
                        id: defaultSale.saleId,
                        saleName: defaultSale.saleName,
                        saleStartDate: defaultSale.saleStartDate,
                        saleEndDate: defaultSale.saleEndDate
                    }));
                }
            }
        }
    });

    return props.children;
}

export default SalesAppDataContext;